/**
 * Normalisasi URL foto profil.
 *
 * API mengembalikan nilai yang bentuknya tidak seragam:
 * - URL penuh (mis. foto dari Google: `https://lh3.googleusercontent.com/...`)
 * - path relatif di server (mis. `../uploads/profile/abc.jpg`)
 * - kosong / `null` / `undefined` untuk user yang belum punya foto
 *
 * Path relatif harus diberi prefix `BASE_URL`, kalau tidak `<img src>` akan
 * mencarinya di origin frontend dan gambarnya gagal dimuat.
 */

const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

// Nilai kosong bisa datang sebagai string karena cookie hanya menyimpan string.
const EMPTY_VALUES = ["", "null", "undefined"];

/**
 * @param {string|null|undefined} value
 * @returns {string} URL siap pakai, atau "" bila tidak ada foto.
 */
export const resolvePhotoUrl = (value) => {
  if (!value) return "";

  const photo = String(value).trim();
  if (EMPTY_VALUES.includes(photo)) return "";

  // Sudah berupa URL absolut (termasuk foto Google) atau data URI: pakai apa adanya.
  if (/^(https?:)?\/\//i.test(photo) || photo.startsWith("data:")) return photo;

  const relativePath = photo.replace(/^(\.\.\/)+/, "").replace(/^\/+/, "");
  return `${BASE_URL}/${relativePath}`;
};
